/**
 * Medallia DXA (Decibel Insight) client-side PII masking.
 *
 * `data-di-mask` is a **valueless / presence-based** HTML attribute — DXA
 * excludes an element's captured content purely because the attribute is
 * present, not because of any value it holds (e.g. `<h1 data-di-mask>Mr. Joe
 * Bloggs</h1>`). In React this must be emitted as an **empty string**
 * (`{ 'data-di-mask': '' }`) so the DOM shows the bare attribute
 * (`data-di-mask=""`). Do NOT use `true` — React renders that as the string
 * `"true"` (`data-di-mask="true"`), which is not the agreed marker.
 *
 * This is the single source of truth for the attribute name/value, consumed
 * by both the display-side masked component library
 * (`components/common/masked/`) and the input-side field wrappers.
 *
 * See `documentation/context/medallia-dxa-integration.md` ("Privacy /
 * masking") for the full masking rules (CD-8245).
 */
export const DI_MASK_ATTRIBUTE = 'data-di-mask' as const;

export type DiMaskProps = { [DI_MASK_ATTRIBUTE]: string };

/**
 * Returns the props object to spread onto a JSX element (or into MUI
 * `inputProps`) to mark it for DXA masking.
 */
export const diMaskProps = (): DiMaskProps => ({
  [DI_MASK_ATTRIBUTE]: ''
});
